import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCompanyModules } from '../hooks/useCompanyModules';
import { isModuleEnabled, modulesFromUser } from '../utils/companyModules';

export default function ProtectedRoute({
  children,
  allowedTypes = [],
  permission,
  permissions = [],
  requireAllPermissions = false,
  module,
  fallbackPath = '/',
}) {
  const {
    isAuthenticated,
    loading,
    permissionsLoading,
    user,
    isFullAccess,
    hasAnyPermission,
    hasAllPermissions,
  } = useAuth();
  const { modules, ready: modulesReady } = useCompanyModules({
    slug: user?.slug,
    companyId: user?.company_id,
    authenticated: !!user,
    seed: modulesFromUser(user),
  });
  if (loading) return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>جاري التحميل...</div>;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (allowedTypes.length > 0 && !allowedTypes.includes(user?.type)) {
    return <Navigate to="/login" replace />;
  }
  if (module) {
    if (!modulesReady) {
      return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>جاري التحميل...</div>;
    }
    if (!isModuleEnabled(modules, module)) return <Navigate to={fallbackPath} replace />;
  }
  if (permission || permissions.length > 0) {
    if (permissionsLoading) {
      return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>جاري التحقق من الصلاحيات...</div>;
    }
    if (!isFullAccess) {
      const required = permission ? [permission, ...permissions] : permissions;
      const allowed = requireAllPermissions
        ? hasAllPermissions(required)
        : required.length === 0
          ? true
          : hasAnyPermission(required);
      if (!allowed) return <Navigate to={fallbackPath} replace />;
    }
  }
  return children;
}
